import React from 'react';
import cn from 'classnames';
import {Button as RocketButton} from '@rocket-ui/components';

type Props = React.ComponentProps<typeof RocketButton>;

export const Button = ({className, fullWidth, ...props}: Props) => {
	return (
		<RocketButton
			theme="black"
			loaderInvert
			{...props}
			fullWidth={fullWidth}
			className={cn('font-medium !h-auto', fullWidth ? undefined : '!w-auto', className)}
		/>
	);
};
